import { tateConfig, yokoConfig } from './sheet.config'

export const S3_CW2603_TestA_211123 = {
  FRONT: {
    EXAM_GROUP_KEY: '02325003111',
    QR_INFO: {
      checkDigit: 3317,
      correctSize: tateConfig.correctedSize,
      correctMarkers: tateConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: tateConfig.correctedRotateQrPos,
      numCheckPosition: tateConfig.correctedNumCheckArea,
      clipScale: 0.8,
      isHorizontal: false
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02325003122',
    QR_INFO: {
      checkDigit: 3325,
      correctSize: yokoConfig.correctedSize,
      correctMarkers: yokoConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: yokoConfig.correctedRotateQrPos,
      numCheckPosition: yokoConfig.correctedNumCheckArea,
      clipScale: 1.0,
      isHorizontal: true
    }
  }
} as const
